let fetch;

if (!import.meta.env.IS_SERVER) {
  fetch = window.fetch;
}
else {
  fetch = require('node-fetch').default; // eslint-disable-line no-undef
}

export default fetch;
